import { useCallback, useEffect, useRef, useState } from "react";
import { Container, Dropdown, Form, Nav, Navbar } from "react-bootstrap";
import { RiMenuUnfoldLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Logo from '../../assets/images/myfx-logo.png';
import MobileLogo from "../../assets/images/myfx-logo.png";
import IconAdmin from '../../assets/images/menu-icon/icon-admin.svg';
import IconCrm from '../../assets/images/menu-icon/icon-crm.svg';
import IconFinance from '../../assets/images/menu-icon/icon-finance.svg';
import IconInventory from '../../assets/images/menu-icon/icon-Inventory.svg';
import IconPos from '../../assets/images/menu-icon/icon-pos.svg';
import IconStaffing from '../../assets/images/menu-icon/icon-staffing.svg';
import { MenuItem } from "../../assets/interfaces/commom_interfaces";
import { MenuKeys, useMenu } from "../../context/MenuContext";
import { GetListCommonCall } from "../../POS/APIServices/POS_API_Services";
import { storeSelectedAction } from "../../Redux/action";
import { BiBell } from "react-icons/bi";

import { GoChevronDown } from "react-icons/go";
import { AiOutlineLogout, AiOutlineUser } from "react-icons/ai";
import { BiHelpCircle } from "react-icons/bi";
import { useOnboarding } from '../../context/OnboardingContext';
import '../Onboarding/Onboarding.css';
import ProfileAvtar from "../../assets/images/default-avatar.jpg";
import ConfirmationModal from "../Common/Modals/ConfirmationModal";
import WebService from "../../Services/WebService";
import { onMessageListener, removeFcmToken } from "../../firebase";
import HelperService from "../../Services/HelperService";
const ModuleNav = () => {
    let navigate = useNavigate();
    const topMenus = ['POS', 'INVENTORY', 'STAFFING', 'CRM', 'FINANCE', 'RESTAURANT_ADMIN'];
    const { selectedMenuKey, setSelectedMenuKey } = useMenu();
    const dispatch = useDispatch();
    const handleMenuClick = (menuKey: any) => {
        setSelectedMenuKey(topMenus.indexOf(menuKey));
        dispatch(storeSelectedAction([]));
    };
    const menuList = useSelector((state: any) => state.items?.menuList);
    const [menus, setMenus] = useState<MenuItem[]>([]);
    useEffect(() => {
        if (menuList && menuList?.length > 0) {
            if (!menuList?.find((item: any) => item.is_enabled && item.code === topMenus[selectedMenuKey])) {
                let mcode = menuList.find((item: any) => item.is_enabled)
                if (mcode) {
                    setSelectedMenuKey(topMenus.indexOf(mcode.code));
                    navigate(getModuleRoute(mcode.code))
                }
            }
            setMenus(menuList);
        }
    }, [menuList]);
    const getNavigationUrl = (code: string): string => {
        const prefixMap: Record<string, string> = {
            POS: "/pos",
            INVENTORY: "/inventory",
            STAFFING: "/staffing",
            CRM: "/crm",
            RESTAURANT_ADMIN: "/restaurant-admin",
            FINANCE: "/finance",
        };
        if (!prefixMap[code]) return "/"; // guard against unknown codes
        const item = menuList?.find((item: any) => item.is_enabled && item.code === code);
        if (item) {
            const subUrl = item.subMenus?.[0]?.url ?? "";
            if (!subUrl || subUrl === "#") {
                const superSubUrl = item.subMenus[0]?.subMenus[0]?.url ?? "";
                return prefixMap[code] + superSubUrl;
            } else {
                return prefixMap[code] + subUrl;
            }
        }
        return "/";
    };
    const getModuleRoute = (code: string) => {
        switch (code) {
            case "POS":
                return getNavigationUrl("POS");
            case "INVENTORY":
                return getNavigationUrl("INVENTORY");
            case "STAFFING":
                return getNavigationUrl("STAFFING");
            case "CRM":
                return getNavigationUrl("CRM");
            case "FINANCE":
                return getNavigationUrl("FINANCE");
            case "RESTAURANT_ADMIN":
                return getNavigationUrl("RESTAURANT_ADMIN");
            default:
                return "/";
        }
    };
    const getModuleIcon = (code: string) => {
        switch (code) {
            case "POS":
                return IconPos;
            case "INVENTORY":
                return IconInventory;
            case "STAFFING":
                return IconStaffing;
            case "CRM":
                return IconCrm;
            case "FINANCE":
                return IconFinance;
            case "RESTAURANT_ADMIN":
                return IconAdmin;
            default:
                return IconPos;
        }
    };
    return (
        <>
            <div className="d-flex">
                <Nav className="module-nav">
                    {menus?.length === 0 && (
                        <p className="text-center mt-3">No menu permissions available for outlet</p>
                    )}
                    {/* {menus?.map((menu: any) => (menu.is_enabled &&
                        menu.subMenus?.some((subMenu: any) => subMenu.is_enabled) && (
                            <Link
                                style={{ padding: '5px 7px' }}
                                key={menu.menu_id}
                                to={getModuleRoute(menu.code)}
                                className={`nav-link ${MenuKeys[selectedMenuKey] === menu.code ? 'active' : ''}`}
                                onClick={() => handleMenuClick(menu.code)}
                            >
                                <img src={getModuleIcon(menu.code)} className="menu-icon" alt="icon" /> {menu.title}
                            </Link>
                        )
                    ))} */}


                    {topMenus.map((code) => {
                        const menu: any = menus?.find((m: any) => m.code === code);
                        if (!menu) return null;
                        if (
                            !menu.is_enabled ||
                            !menu.subMenus?.some((sub: any) => sub.is_enabled)
                        ) {
                            return null;
                        }
                        return (
                            <Link
                                key={menu.menu_id}
                                to={getModuleRoute(menu.code)}
                                className={`nav-link tour-module-${menu.code} ${MenuKeys[selectedMenuKey] === menu.code ? "active" : ""
                                    }`}
                                style={{ padding: "5px 7px" }}
                                onClick={() => handleMenuClick(menu.code)}
                            >
                                <img
                                    src={getModuleIcon(menu.code)}
                                    className="menu-icon"
                                    alt="icon"
                                />{" "}
                                {menu.title}
                            </Link>
                        );
                    })}
                    {/* <div className="d-flex align-items-end justify-content-end">
                    <BellFill className="mt-2" />
                </div> */}
                </Nav>
            </div>
            {/* <Link
                    to="/pos/dashboard"
                    className={`nav-link ${selectedMenuKey === MenuKeys.POS ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.POS)}
                >
                    <img src={IconPos} className="menu-icon" alt="icon" /> POS
                </Link>
                <Link
                    to="/inventory/dashboard"
                    className={`nav-link ${selectedMenuKey === MenuKeys.INVENTORY ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.INVENTORY)}
                >
                    <img src={IconInventory} className="menu-icon" alt="icon" /> Inventory
                </Link>
                <Link
                    to="/staffing/employee-directory"
                    className={`nav-link ${selectedMenuKey === MenuKeys.STAFFING ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.STAFFING)}
                >
                    <img src={IconStaffing} className="menu-icon" alt="icon" /> Staffing
                </Link>
                <Link
                    to="/crm/dashboard"
                    className={`nav-link ${selectedMenuKey === MenuKeys.CRM ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.CRM)}
                >
                    <img src={IconCrm} className="menu-icon" alt="icon" /> CRM
                </Link>
                <Link
                    to="/finance/dashboard"
                    className={`nav-link ${selectedMenuKey === MenuKeys.FINANCE ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.FINANCE)}
                >
                    <img src={IconFinance} className="menu-icon" alt="icon" /> Finance
                </Link>
                <Link
                    to="/restaurant-admin/dashboard"
                    className={`nav-link ${selectedMenuKey === MenuKeys.RESTAURANT_ADMIN ? 'active' : ''}`}
                    onClick={() => handleMenuClick(MenuKeys.RESTAURANT_ADMIN)}
                >
                    <img src={IconAdmin} className="menu-icon" alt="icon" /> Restaurant Admin
                </Link> */}
        </>
    )
}

const Header = () => {
    const Details = useSelector((state: any) => state?.items?.meDetails);
    const selectedOutlets = useSelector((state: any) => state?.items?.storeSelectedOutlet);
    let navigate = useNavigate();
    const { selectedMenuKey } = useMenu();
    const [menuOpen, setMenuOpen] = useState(false);
    const [showLogout, setShowLogout] = useState(false);
    const { resetTour } = useOnboarding();
    const [unreadCount, setUnreadCount] = useState(0);
    const handleMenuToggle = () => {
        document.body.classList.toggle('show-mo-menu');
        setMenuOpen((prev: boolean) => !prev);
    };
    const isFetchingRef = useRef(false);

    const [notifications, setNotifications] = useState<any[]>([]);
    const [notifLoading, setNotifLoading] = useState(false);
    const [loadingMoreNotifications, setLoadingMoreNotifications] = useState(false);
    const [nextNotificationPage, setNextNotificationPage] = useState<number>(1);
    const [hasMoreNotifications, setHasMoreNotifications] = useState(false);
    const [notificationKeyword, setNotificationKeyword] = useState("");
    const [debouncedNotificationKeyword, setDebouncedNotificationKeyword] = useState("");
    const [isAiNotifications, setIsAiNotifications] = useState(false);
    const notificationDropdownOpenRef = useRef(false);
    const selectedOutletId = selectedOutlets?.[0]?.id || localStorage.getItem("outlet_id") || "";
    const getActiveModuleInfo = () => {
        switch (selectedMenuKey) {
            case MenuKeys.POS:
                return { icon: IconPos, text: 'POS' };
            case MenuKeys.INVENTORY:
                return { icon: IconInventory, text: 'Inventory & Waste Management' };
            case MenuKeys.STAFFING:
                return { icon: IconStaffing, text: 'Staffing' };
            case MenuKeys.CRM:
                return { icon: IconCrm, text: 'CRM' };
            case MenuKeys.FINANCE:
                return { icon: IconFinance, text: 'Finance' };
            case MenuKeys.RESTAURANT_ADMIN:
                return { icon: IconAdmin, text: 'Restaurant Admin' };
            default:
                return { icon: IconPos, text: 'POS' };
        }
    };
    const getUnreadCount = useCallback(() => {
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        WebService.getAPI({
            action: "staffs/notifications/unread-count",
            body: null,
            isShowError: true,
        }).then((res: any) => {
            setUnreadCount(res?.unread_count || 0);
        }).catch(() => {
            setUnreadCount(0);
        }).finally(() => {
            setTimeout(() => {
                isFetchingRef.current = false;
            }, 5000);
        });
    }, []);

    const fetchNotifications = useCallback((page = 1, append = false) => {
        if (append) {
            setLoadingMoreNotifications(true);
        } else {
            setNotifLoading(true);
            setNextNotificationPage(1);
            setHasMoreNotifications(false);
        }

        const params = {
            page,
            limit: 10,
            sortBy: "created_at",
            orderBy: "DESC",
            keyword: debouncedNotificationKeyword.trim(),
            isAi: isAiNotifications
        };

        GetListCommonCall("staffs/notifications/list", params).then((res: any) => {
            const list = res?.data || [];

            if (list.length > 0) {
                setNotifications((prev) => append ? [...prev, ...list] : list);
            } else if (!append) {
                setNotifications([]);
            }

            setNextNotificationPage(res?.nextPage || -1);
            setHasMoreNotifications(res?.nextPage !== -1 && !!res?.nextPage);
        }).finally(() => {
            setNotifLoading(false);
            setLoadingMoreNotifications(false);
        });
    }, [debouncedNotificationKeyword, isAiNotifications]);

    useEffect(() => {
        const timeout = window.setTimeout(() => {
            setDebouncedNotificationKeyword(notificationKeyword);
        }, 350);

        return () => window.clearTimeout(timeout);
    }, [notificationKeyword]);

    useEffect(() => {
        getUnreadCount();
        setNotifications([]);
        setNextNotificationPage(1);
        setHasMoreNotifications(false);

        if (notificationDropdownOpenRef.current) {
            fetchNotifications(1);
        }
    }, [selectedOutletId, getUnreadCount]);

    useEffect(() => {
        if (notificationDropdownOpenRef.current) {
            fetchNotifications(1);
        }
    }, [debouncedNotificationKeyword, isAiNotifications, fetchNotifications]);

    useEffect(() => {
        const refreshNotifications = () => {
            getUnreadCount();
            if (notificationDropdownOpenRef.current) {
                fetchNotifications(1);
            }
        };

        const unsubscribeFromMessage = onMessageListener(refreshNotifications);
        const serviceWorkerMessageHandler = (event: MessageEvent) => {
            if (event.data && typeof event.data === "object") {
                refreshNotifications();
            }
        };
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.addEventListener("message", serviceWorkerMessageHandler);
        }
        return () => {
            if (unsubscribeFromMessage) {
                unsubscribeFromMessage();
            }
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.removeEventListener("message", serviceWorkerMessageHandler);
            }
        };
    }, [getUnreadCount, fetchNotifications]);

    const loadMoreNotifications = () => {
        if (!loadingMoreNotifications && hasMoreNotifications && nextNotificationPage !== -1) {
            fetchNotifications(nextNotificationPage, true);
        }
    };
    const handleLogout = () => {
        WebService.addLoader("deleteBtnModal");
        removeFcmToken();
        WebService.removeLoader("deleteBtnModal");
        setShowLogout(false);
    };
    const markAsRead = async (notificationId: any) => {
        try {
            WebService.putAPI({
                action: `staffs/notifications/mark-read/${notificationId}`,
                body: {},
                isShowError: true,
                isHideToast: true
            }).then((res: any) => {
                setNotifications((prev) =>
                    prev.map((item) =>
                        item.id === notificationId
                            ? {
                                ...item,
                                is_read: true
                            }
                            : item
                    )
                );

                setUnreadCount((prev) =>
                    prev > 0 ? prev - 1 : 0
                );

            }).catch((error: any) => {
                console.log(error);
            });
        } catch (error) {
            console.log(error);
        }
    }
    const markAllAsRead = async () => {
        try {
            WebService.putAPI({
                action: `staffs/notifications/mark-all-read`,
                body: {},
                isShowError: true,
                isHideToast: true
            }).then((res: any) => {
                setNotifications((prev) =>
                    prev.map((item) => ({
                        ...item,
                        is_read: true
                    }))
                );
                setUnreadCount(0);
            }).catch((error: any) => {
                console.log(error);
            })
        } catch (error) {
            console.log(error);
        }

    };
    const activeModule = getActiveModuleInfo();
    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar>
                        <a className={`text-primary-2 d-lg-none mo-menu-toggle${menuOpen ? ' mo-menu-open' : ''}`}
                            onClick={handleMenuToggle}  >
                            <RiMenuUnfoldLine size="24" />
                        </a>
                        <Navbar.Brand className="">
                            <img src={Logo} width={45} height={45} alt='Logo' className=" align-text-top d-none d-lg-block" />
                            <img src={MobileLogo} width={45} height={45} alt='Logo' className=" align-text-top d-lg-none d-block" />
                        </Navbar.Brand>
                        <div className="d-block d-lg-none ms-auto">
                            <Dropdown className="module-dd" align="end" autoClose='outside'>
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                    <img src={activeModule.icon} className="menu-icon" alt="icon" /> {activeModule.text}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <ModuleNav />
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="d-none d-lg-block">
                            <ModuleNav />
                        </div>
                        <div className="ms-auto d-flex gap-2 align-items-center" >
                            <Dropdown
                                align="end"
                                autoClose="outside"
                                className="notification-actions mb-1"
                                onToggle={(open) => {
                                    notificationDropdownOpenRef.current = open;
                                    if (open) {
                                        fetchNotifications(1);
                                    }
                                }}
                            >
                                <Dropdown.Toggle variant="link" className="position-relative p-0 no-arrow">
                                    <BiBell size={22} className="text-primary" />
                                    {unreadCount > 0 && (
                                        <span
                                            className="notification-badge"
                                        >
                                            {unreadCount > 9 ? "9+" : unreadCount}
                                        </span>
                                    )}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="notification-dropdown">
                                    <div className="notification-header">
                                        <div className="d-flex align-items-center gap-2">
                                            <Form.Check
                                                type="switch"
                                                id="ai-notification-switch"
                                                className="notification-ai-toggle gap-1"
                                                label="AI"
                                                checked={isAiNotifications}
                                                onChange={(e) => setIsAiNotifications(e.target.checked)}
                                            />
                                            <span>Notifications</span>
                                        </div>
                                        {unreadCount > 0 && (
                                            <button
                                                className="mark-all-btn"
                                                onClick={markAllAsRead}
                                            >Mark all read </button>
                                        )}
                                    </div>
                                    <div className="notification-search">
                                        <Form.Control
                                            size="sm"
                                            value={notificationKeyword}
                                            onChange={(e) => setNotificationKeyword(e.target.value)}
                                            placeholder="Search notifications"
                                        />
                                    </div>
                                    <div className="notification-list">
                                        {notifLoading ? (
                                            <div className="notification-empty">
                                                Loading...
                                            </div>
                                        ) :
                                            notifications.map((n) => (
                                                <div
                                                    key={n.id}
                                                    className={`notification-item ${!n.is_read ? "unread" : ""
                                                        }`}
                                                    onClick={() => {
                                                        if (!n.is_read) {
                                                            markAsRead(n.id);
                                                        }
                                                    }}
                                                >
                                                    <div className="notification-content">
                                                        <div className="notification-title">
                                                            {n.title}
                                                        </div>
                                                        <div className="notification-body">
                                                            {n.body}
                                                        </div>
                                                        <div className="notification-time">
                                                            {HelperService.getFormatedDate(n.created_at)}
                                                        </div>
                                                    </div>
                                                    {!n.is_read && (
                                                        <div className="unread-dot" />
                                                    )}
                                                </div>
                                            ))

                                        }

                                        {!notifLoading &&
                                            notifications.length === 0 && (
                                                <div className="notification-empty">
                                                    No notifications
                                                </div>
                                            )}



                                        {!notifLoading && hasMoreNotifications && (
                                            <button
                                                className="notification-load-more"
                                                disabled={loadingMoreNotifications}
                                                onClick={loadMoreNotifications}
                                            >
                                                {loadingMoreNotifications ? "Loading..." : "Load more"}
                                            </button>
                                        )}

                                    </div>

                                </Dropdown.Menu>


                                {/* <Dropdown.Menu className="notification-dropdown">
                                    <div className="px-3 py-2 fw-bold">
                                        Notifications
                                    </div>
                                    <div style={{ maxHeight: 300, overflowY: "auto" }}>
                                        {notifLoading && (
                                            <div className="px-3 py-2 text-muted">
                                                Loading…
                                            </div>
                                        )}
                                        {!notifLoading && notifications.length === 0 && (
                                            <div className="px-3 py-2 text-muted">
                                                No notifications
                                            </div>
                                        )}
                                        {notifications.map((n, i) => (
                                            <div key={i} className="px-3 py-2 border-bottom">
                                                <div className="font-14">{n.message}</div>
                                                <div className="text-muted small mt-1">{n.time}</div>
                                            </div>
                                        ))}
                                    </div>
                                </Dropdown.Menu> */}
                            </Dropdown>
                            <Dropdown className="profile-dd">
                                <Dropdown.Toggle variant="link" className="no-arrow text-decoration-none" >
                                    <div className='d-flex gap-2 align-items-center px-1'>
                                        <p className='font-14 mb-0 text-dark font-medium'>{Details?.name}</p>
                                        <img src={Details?.profile_pic ?? ProfileAvtar} width={20} height={20} className=" rounded-circle object-fit-cover" alt='' />
                                    </div>
                                    <GoChevronDown size={14} className='icon' />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end" >
                                    <Dropdown.Item onClick={() => navigate("/profile")}>
                                        <AiOutlineUser size={14} className="me-2" /> My Profile
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => resetTour()}>
                                        <span className="onb-replay-item">
                                            <BiHelpCircle size={14} className="me-2" /> Replay Tour
                                            <span className="onb-replay-badge">Guide</span>
                                        </span>
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => setShowLogout(true)}>
                                        <AiOutlineLogout size={14} className="me-2" /> Logout
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Navbar>
                </Container>
            </header>
            <ConfirmationModal
                show={showLogout}
                setShow={setShowLogout}
                heading="Logout"
                acceptButtonText="LOGOUT"
                rejectButtonText="CANCEL"
                message="Are you sure you want to logout?"
                handleYesClick={handleLogout}
            />
        </>
    )
}
export default Header;
